import { collection, addDoc, doc, setDoc } from "firebase/firestore"; 
import db from "./firebase";

export const firebaseSaveJournalEntry = async(journalEntry)=>{
    try {
        const docRef = await addDoc(collection(db, "demoEntries"), journalEntry);
        return docRef.id;
      } catch (e) {
        console.error("Error adding document: ", e);
        return null;
    }
}

export const firebaseUpdateJournalEntry = async(id, newEntry)=>{
    await setDoc(doc(db, "demoEntries", id), newEntry);
    return 1;
}
